import { GridItem, TextInputField } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Field, useField } from "formik";
import { useTranslation } from "react-i18next";

import {
  CountrySelect,
  ProvinceSelect,
} from "../../../../components/AddressInput";
import { customFieldLabels } from "../../../../utils/address-utils";

type BirthPlaceCheckField = components["schemas"]["BirthPlaceCheckField"];

export function BirthplaceInputField({
  field: config,
}: {
  field: BirthPlaceCheckField;
}) {
  const { t } = useTranslation();

  const birthCountry = useField(`${config.name}.birth_country`)[0];
  const [, , provinceHelpers] = useField(`${config.name}.birth_province_state`);
  const labels = customFieldLabels[birthCountry.value] ?? customFieldLabels.CA;

  return (
    <>
      <GridItem>
        <CountrySelect
          name={`${config.name}.birth_country`}
          label={`${t("Country")} ${t("of birth")}`}
          onChange={() => provinceHelpers.setValue("")}
          isRequired
          testID="birth-details-country-of-birth-select"
        />
      </GridItem>

      <GridItem>
        <ProvinceSelect
          name={`${config.name}.birth_province_state`}
          label={`${labels.province_state} ${t("of birth")}`}
          country={birthCountry.value}
          testID="birth-details-province-of-birth-select"
        />
      </GridItem>

      <GridItem>
        <Field
          name={`${config.name}.birth_city`}
          label={`${labels.city} ${t("of birth")}`}
          as={TextInputField}
          isRequired
          testID="birth-details-city-of-birth-input"
        />
      </GridItem>
    </>
  );
}
